<template>
    <div class="register-account">
        <div class="modal fade register-page1" id="register-btn" data-bs-backdrop="static" data-bs-keyboard="false"
            tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="container-fluid login-module-wrapper">
                            <button @click="refreshData()" type="button" class="btn-close close-top" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="row">
                                <div class="col-12 col-md-5">
                                    <div class="text-center">
                                        <img  rel="preload"  class="img-fluid logoregisterPage" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo">
                                        <!-- <img  rel="preload"  src="@/assets/images/betfairlogo.webp" class="img-fluid m-top"> -->
                                        <img  rel="preload"  src="@/assets/images/loginImg2.webp" class="img-fluid filterlogin m-top">
                                    </div>
                                </div>
                                <div class="col-12 col-md-7">
                                    <!-- <h2 class="regi-acc">{{ $t('register-account','Register account')}}</h2> -->
                                    <form class="reg-form">
                                        <div class="form-group">
                                            <!-- <label>Mobile Number*</label> -->
                                            <div class="get-mob" :disabled="otpSent" :class="{ 'get-mob': !otpSent, 'get-mob-dis': otpSent }">
                                                <div class="col-auto">
                                                    <select class="form-select w_length_s" v-model="form.code" :disabled="otpSent">
                                                    <option :value="allowedCountry.phonecode" v-for="(allowedCountry, countryIndex) in $siteSettings.data?.country_code_list" :key="countryIndex">+{{ allowedCountry.phonecode }}</option>
                                                </select>       
                                                </div>
                                                <div class="inp-img">
                                                    <img  rel="preload"   src="@/assets/images/mob_icon.svg" alt="">
                                                </div>
                                                <input v-model="form.mobileNo"  maxlength="10" :disabled="otpSent" type="tel" @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999);"  :class="{ enabled: !otpSent, disabled: otpSent }"
                                                class="form-control add" id="autoSizingInput" :placeholder="$t('enter-phone-number','Enter Phone Number') ">
                                                <div class="get-code">
                                                    <button class="loader-btn" :disabled=" timerRunning" :class="{ 'disabled-login': timerRunning }" type="button" @click="otpBtnCall()">
                                                        {{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}
                                                        <span><b></b><b></b><b></b></span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div>
                                                <template v-if="phnInit && checkValidation?.mobile?.length > 0" >
                                                    <p v-for="(err, index) in checkValidation?.mobile" :key="index" class="wrong-message mt-1">
                                                        {{ $t(err.lang, err.error) }}
                                                    </p>
                                                </template>
                                                <p v-if="otpBtnInit && form.mobileNo?.length == 10 && !isOtpApiCalled" class="wrong-message mt-1">
                                                    {{$t('please-click-on-send-otp','Please Click On Get OTP')}}
                                                </p>
                                            </div>
                                            
                                        </div>
                                        
                                        <div class="get-input-field for">
                                            <!-- <label>OTP*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.otp" type="text"  maxlength="6" @input="form.otp = $helper.sanitizeNumber(form.otp, 999999);" class="form-control"
                                                :placeholder="$t('enter-otp','Enter OTP')" :disabled="!isOtpApiCalled" :class="{ enabled: isOtpApiCalled, disabled: !isOtpApiCalled }">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/key.svg" alt=""></div>
                                                <div v-if="init && checkValidation?.otp?.length > 0">
                                                    <p v-for="(err, index) in checkValidation?.otp" :key="index" class="wrong-message mt-1">
                                                        {{ $t(err.lang, err.error) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div class="get-input-field for">
                                            <div class="refer-code-hyper" v-if ="!isSetUserId">
                                                <a href="javascript:void(0)" @click="isSetUserId =! isSetUserId">{{$t('set-user-id','Want to set UserID')}}?</a>
                                            </div>
                                            <div class="form-group" v-if ="isSetUserId">
                                                <input type="text" name="userNumber" :placeholder="$t('enter-user-id','Enter User ID')"  maxlength="25" minlength="6" v-model="form.userName" class="form-control" :disabled="!isOtpApiCalled" :class="{ enabled: isOtpApiCalled, disabled: !isOtpApiCalled }" />
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/user_icon.svg" alt=""></div>
                                            </div>
                                        </div>
                                        <div v-if="init && checkValidation?.userId?.length > 0">
                                            <p v-for="(err, index) in checkValidation?.userId" :key="index" class="wrong-message mt-1">
                                                {{ $t(err.lang, err.error) }}
                                            </p>
                                        </div>

                                        <div class="get-input-field for">
                                            <!-- <label>Password*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.password" @input="form.password = $helper.sanitizeDetails('password', form.password, 20);" :type="passwordFieldType" class="form-control"
                                                    maxlength="20" :placeholder="$t('enter-pass','Enter Password')" :disabled="!isOtpApiCalled" :class="{ enabled: isOtpApiCalled, disabled: !isOtpApiCalled }">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/lock_icon.svg" alt=""></div>
                                                <div class="eye-icn-sec" @click="togglePasswordVisibility('password')" v-if="!isDisabled">
                                                    <img  rel="preload"  v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                                    <img  rel="preload"  v-else src="@/assets/images/eye-open.webp" alt="">
                                                </div>
                                                <div v-if="init && checkValidation?.password?.length > 0" >
                                                    <p v-for="(err, index) in checkValidation?.password" :key="index" class="wrong-message mt-1">
                                                    {{ $t(err.lang, err.error) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="get-input-field for">
                                            <!-- <label>Confirm Password*</label> -->
                                            <div class="form-group">
                                                <input v-model="form.confirmPassword" :type="confPasswordFieldType" maxlength="20" @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20);" required="1" minlength="8" class="form-control"
                                                :placeholder="$t('enter-conf-password','Enter Confirm Password')" :disabled="!isOtpApiCalled" :class="{ enabled: isOtpApiCalled, disabled: !isOtpApiCalled }">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/lock_icon.svg" alt=""></div>
                                                <div class="eye-icn-sec" @click="togglePasswordVisibility" v-if="!isDisabled">
                                                    <img  rel="preload"  v-if="confPasswordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                                    <img  rel="preload"  v-else src="@/assets/images/eye-open.webp">
                                                </div>
                                                <div v-if="init && checkValidation?.confirmPassword?.length > 0">
                                                    <p v-for="(err, index) in checkValidation?.confirmPassword" :key="index" class="wrong-message mt-1">
                                                        {{ $t(err.lang, err.error) }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div class="get-input-field for">
                                            <div class="refer-code-hyper" v-if ="!isRefral && !hasUrlReferer">
                                                <a href="javascript:void(0)" @click="isRefral =! isRefral">{{$t('have-a-refferal-code','Have a referral code')}}?</a>
                                            </div>
                                            <div class="form-group" v-if ="isRefral || hasUrlReferer">
                                                <input v-model="form.referCode" :disabled="hasUrlReferer || !isOtpApiCalled" @input="form.referCode = $helper.sanitizeNumber(form.referCode,999999);"  required="1" type="text" class="form-control"
                                                    :placeholder="$t('enter-referral-code-optional', 'Enter Refer Code (Optional)')" :class="{ enabled: isOtpApiCalled, disabled: !isOtpApiCalled }">
                                                <div class="inp-img"><img  rel="preload"   src="@/assets/images/reff.webp" alt=""></div>
                                            </div>
                                        </div>
                                        <button type="button"  @click="signUpCall()" class="btn btn-register loader-btn mt-0">
                                            {{ $t('register','Register')}}
                                            <span><b></b><b></b><b></b></span>
                                        </button>
                                                <h3 class="whats-with" v-if="$siteSettings?.data?.social_link?.whatsappno1">
                                                    {{$t('get-your-ready-made-id-from-whatsapp','Get Your Ready-Made ID From Whatsapp')}}
                                                </h3>
                                        <div v-if="$siteSettings?.data?.social_link?.whatsappno1" class="button-whatsapp">
                                            <a :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" class="btn-whatsapp" target="_blank">
                                                <img  rel="preload"  src="@/assets/images/whatsapp.webp" alt="">
                                                    {{ $t('whatsapp-now','Whatsapp Now')}}
                                            </a>
                                        </div>
                                        <p class="whats-with-acc">{{ $t('already-have-an-account','Already have an account')}}? 
                                            <a ref="open_login_modal" data-bs-toggle="modal" href="#staticBackdrop-one" @click="refreshData()">
                                                {{ $t('login','Login')}}
                                            </a>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';
export default {
    name: 'SignUp',
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                otp: [],
                userName: "",
                password: "",
                confirmPassword: "",
                referCode: this.getQueryParam("refer_code", window.location.href),
            },
            phnInit: false,
            loading: false,
            otpBtnInit:false,
            isRefral:false,
            hasUrlReferer: false,
            isSetUserId: false
        };
    },
    computed: {
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'signup',
                this.form.mobileNo, 
                this.form.otp, 
                this.form.password,
                this.form.confirmPassword
            );
            if(this.init || this.phnInit){
                return validationErrors;
            }
        },
    },
    created(){
        if((window.location.href).includes('refer_code')) {
            this.hasUrlReferer = true;
        }
    },
    mounted(){        
        if(this.$route.name == 'sign-up' && !this.$auth.status){
           
           setTimeout(()=> {
                this.$helper.openModal('#register-btn')
            }, 1000)
            this.$router.push({name: 'Home'});
        }
        else if(this.$route.name == 'sign-up' && this.$auth.status){
            this.$router.push('Home')
        }
    },
    methods: {
        signUpCall() {
            this.phnInit = true;
            this.otpBtnInit = true;
            if (!this.otpSent){ 
                return
            } else {
                this.init = true;
                if(Object.keys(this.checkValidation).length === 0) {
                    this.signUpServiceCall();
                }
            }
        },
        otpBtnCall(){
            this.phnInit=true;
            this.otpBtnInit=true;
            this.sendOtpCall();
        },
        signUpServiceCall() {
            this.loading = true;
            let isDownLine = this.getQueryParam("downline", window.location.href);
            let data = {
                "userid": this.form.userName ? this.form.userName : null, 
                "phone": this.form.mobileNo,
                "password": this.form.password,
                "otp": this.getOtp(),
                "isDownLine": isDownLine ? isDownLine : false,
                "refer_code": this.form.referCode,
                "cncode": this.form.code,
            };
            this.$apiCall('post', 'REGISTER', data).then(response => {
                if (response) {
                    this.loading = false;
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        } else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$helper.closeModal('register-btn');
                            this.$helper.showLogin();                        
                        }
                    }
                }
            }).catch(error => {
                if (error)
                    this.loading = false;
                    this.$errorToast(error[0]);
            });
        },
        getQueryParam(paramName, url) {
            if (!url) url = location.href;
            paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + paramName + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        }
    },
}
</script>

<style>
.form-control.refer-code:disabled {
    background-color: #a8a2a2;
    opacity: 1;
}

</style>

